import request from '@/utils/request'


// 查询浏览记录量
export function getBrowseCount(data) {
  return request({
    url: '/web/browse/getView',
    method: 'post',
    data: data
  }).then(res => res.data)
}

// 查询浏览记录量
export function getBrowseCount11(recid) {
  return request({
    url: '/web/browse/getBrowseCount/' + recid,
    method: 'get'
  })
}
